module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_03@2x-dccb514f3ed50400d898ea50f2eb8aa0.webp";